import React from 'react';
import MultiSelect from '../multiselect';

/**
 * Maps filter definitions to col-md-4 MultiSelect columns (shared by dashboard filter panels).
 *
 * @param {Array<{ label: string, options: Array, name: string, value: *, multiSelect?: boolean }>} listOfFilters
 * @param {Function} updateFilters
 * @param {Object} [config]
 * @param {string[]} [config.hiddenFieldNames] — skip these names (empty fragment)
 * @param {function(Object): *} [config.transformValue] — (filterItem) => value passed to MultiSelect
 */
export function renderDashboardMultiSelectRows(
  listOfFilters,
  updateFilters,
  config = {}
) {
  const { hiddenFieldNames = [], transformValue } = config;

  return listOfFilters.map((item, index) => {
    const { label, options, name, value, multiSelect } = item;
    const key = name != null ? String(name) : String(index);

    if (hiddenFieldNames.length && hiddenFieldNames.includes(name)) {
      return <React.Fragment key={key} />;
    }

    const resolvedValue = transformValue ? transformValue(item) : value;

    const multiProps =
      multiSelect !== undefined ? { isMulti: multiSelect } : {};

    return (
      <div className="col-md-4" key={key}>
        <MultiSelect
          updateFilters={updateFilters}
          label={label}
          options={options}
          name={name}
          value={resolvedValue}
          {...multiProps}
        />
      </div>
    );
  });
}
